import React, { useState, useEffect } from "react";
import styles from "./ScrollToTopButton.module.css";

export default function ScrollToTopButton({
    size = 50,
    color = "white",
    backgroundColor = "#333",
    bottom = "30px",
    right = "30px",
    showAfter = 200, // 몇 px 내려가면 버튼 표시할지
}) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > showAfter);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [showAfter]);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (!visible) return null;

    return (
        <button
            onClick={scrollToTop}
            className={styles.scrollButton}
            style={{
                width: `${size}px`,
                height: `${size}px`,
                fontSize: `${size * 0.4}px`,
                bottom,
                right,
                backgroundColor,
                color,
            }}
        >
            ⬆
        </button>
    );
}
